query getSeoData {
  siteInfo {
    seoData {
      metaTitle
      metaDescription
      seoTitle
      seoText
      h1
      ogTitle
      ogDescription
    }
  }
}
